import { Button } from "@mui/material";
import styled from "styled-components";

export const ButtonLink = styled(Button)`
  &.delivery-btn-link.buttonLink {
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    font-weight: normal;

    text-transform: unset;
    padding: 0;
    color: ${({ theme }) => theme.uptimeColors.generalColors.button?.hyperlink?.enabled};
    float: right;
    background-color: transparent !important;
    text-decoration: none !important;
    font-family: ${({ theme }) => theme.uptimeFonts.primary};
    font-weight: bold !important;
    &:hover {
      text-decoration: underline !important;
      color: ${({ theme }) => theme.uptimeColors.generalColors.button?.hyperlink?.hover} !important;
    }
    .MuiButton-label {
      font-family: ${({ theme }) => theme.uptimeFonts.primary};
      display: flex;
      justify-content: flex-end;
      font-size: 14px;
      font-weight: 600;
      &:hover {
        text-decoration: underline;
      }
    }
  }
`;
